import { combineReducers } from 'redux';
// Import reducers
import table from './geolocks_panel_reducer';

export default combineReducers({
	table
});
